module.exports = __webpack_public_path__ + "img/w3_trash_solid_recover_white.e0df0f09.png";